import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-linux-m3-series',
  templateUrl: './linux-m3-series.component.html',
  styleUrls: []
})
export class LinuxM3SeriesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}